import { axiosGroup } from "./axiosGroup";

export interface CreateBackgroundRequest {
  name: string;
  description?: string;
  image: string; // base64 format
}

export interface Background {
  id: string;
  name: string;
  description?: string;
  url: string;
}

export interface UpdateBackgroundRequest {
  name?: string;
  description?: string;
}

export const createBackground = async (payload: CreateBackgroundRequest) => {
  const result = await axiosGroup.axiosServerAPI.post(
    "/admin/background",
    payload
  );
  return result.data;
};

export const getBackgrounds = async () => {
  const result = await axiosGroup.axiosServerAPI.get("/backgrounds");
  return result.data;
};

export const deleteBackground = async (id: string) => {
  const result = await axiosGroup.axiosServerAPI.delete(
    `/admin/background/${id}`
  );
  return result.data;
};

export const updateBackgroundInfo = async (
  id: string,
  payload: UpdateBackgroundRequest
) => {
  const result = await axiosGroup.axiosServerAPI.put(
    `/admin/background/${id}`,
    payload
  );
  return result.data;
};

